import app from "../firebase";
import { getAuth, signOut } from "firebase/auth";
import {
  getFirestore,
  doc,
  getDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import router from "@/router";
import Notify from 'quasar/src/plugins/Notify.js';;

const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth();

const state = {
  currentUser: {},
  userPasswords: [],
  loadingStatus: false,
};
const mutations = {
  setUserData(state, payload) {
    state.currentUser = payload;
  },
  setAllUserPasswords(state, payload) {
    state.userPasswords = payload;
  },
  setUserPasswords(state, payload) {
    state.userPasswords = payload;
  },
  setLoadingStatus(state, payload) {
    state.loadingStatus = payload;
  },
  setNewPassword(state, payload) {
    state.userPasswords.unshift(payload);
  },
  setDeletePassword(state, payload) {
    state.userPasswords = state.userPasswords.filter((pass) => {
      return pass.id !== payload;
    });
  },
};
const actions = {
  async getUserData({ commit }, payload) {
    commit("setLoadingStatus", true);
    const docRef = doc(db, "users", payload);
    const docSnap = await getDoc(docRef);
    commit("setUserData", docSnap.data());
  },
  async getUserPasswords({ commit }) {
    const getPasswords = httpsCallable(functions, "getPasswords");
    let passwords = await getPasswords();
    commit("setAllUserPasswords", passwords.data);
    commit("setLoadingStatus", false);
  },
  emptyUserData({ commit }) {
    commit("setUserData", {});
    commit("setUserPasswords", []);
  },
  async createUserPassword({ commit }, payload) {
    payload.owner = getAuth(app).currentUser.uid;
    payload.createdAt = Date.now();
    if (!payload.service) payload.service = "fas fa-star";
    commit("setLoadingStatus", true);
    const storePassword = httpsCallable(functions, "storePassword");
    let resp = await storePassword(payload);
    payload.id = resp.data;
    commit("setNewPassword", payload);
    commit("setLoadingStatus", false);
    Notify.create({
      message: "Password created successfully",
      color: "green-6",
      icon: "check",
      badgeColor: "amber-6",
      progress: true,
      classes: "pc-font pc-semibold higher-toast",
      timeout: 1000,
    });
  },
  deletePassword({ commit }, payload) {
    if (confirm("Delete password?")) {
      commit("setDeletePassword", payload);
      router.push("/");
      deleteDoc(doc(db, "passwords", payload));
    }
  },
  async updateUserData({ commit }, payload) {
    commit("setLoadingStatus", true);
    let uid = getAuth(app).currentUser.uid;
    let newData = {
      name: payload.name,
      lastName: payload.lastName,
    };
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, newData);
    commit("setLoadingStatus", false);
  },
  async deleteAllUserPasswords({ commit }) {
    if (state.userPasswords.length <= 0) {
      alert("There are no passwords to delete.");
      return;
    }
    if (confirm("Delete all your passwords?")) {
      commit("setLoadingStatus", true);
      const deletePasswords = httpsCallable(
        functions,
        "deleteAllUserPasswords"
      );
      await deletePasswords();
      commit("setAllUserPasswords", []);
      commit("setLoadingStatus", false);
      Notify.create({
        message: "All passwords deleted successfully.",
        color: "green-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 2000,
      });
    }
  },
  async deleteAllUserData({ commit }) {
    if (confirm("Delete my account and passwords?")) {
      commit("setLoadingStatus", true);
      const deletePasswords = httpsCallable(
        functions,
        "deleteAllUserPasswords"
      );
      const deleteUser = httpsCallable(functions, "deleteUserInfoAndAccount");
      await deletePasswords();
      await deleteUser();
      await signOut(auth);
      commit("setLoadingStatus", false);
      Notify.create({
        message: "All account info deleted successfully.",
        color: "green-6",
        icon: "check",
        badgeColor: "amber-6",
        progress: true,
        classes: "pc-font pc-semibold higher-toast",
        timeout: 2000,
      });
    }
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
